import { Component, inject, input, output, signal, OnInit } from '@angular/core';

import { UserProfileStore } from './store/user-profile.store';
import {
  ProfileFormComponent,
  SessionsListComponent,
  TabsNavigationComponent,
  ChangePasswordFormComponent,
} from './components';
import { FeatureHeaderComponent } from '../navigation/feature-header.component';
import { TabItem } from '../../types';

@Component({
  standalone: true,
  imports: [
    FeatureHeaderComponent,
    ProfileFormComponent,
    SessionsListComponent,
    TabsNavigationComponent,
    ChangePasswordFormComponent,
  ],
  selector: 'sb-user-profile',
  templateUrl: './user-profile.component.html',
})
export class UserProfileComponent implements OnInit {
  private userProfileStore = inject(UserProfileStore);

  hideCloseButton = input<boolean>(true);
  closeClick = output<void>();

  // Component state
  activeTab = signal<'profile' | 'sessions' | 'change-password'>('profile');

  // Tab configuration
  tabItems: TabItem[] = [
    {
      id: 'profile',
      label: 'Profile Information',
    },
    {
      id: 'change-password',
      label: 'Change Password',
    },
    {
      id: 'sessions',
      label: 'Active Sessions',
    },
  ];

  /**
   * Initialize the component
   */
  ngOnInit() {
    // Load user data from storage first
    this.userProfileStore.loadFromStorage();
  }

  /**
   * Handle tab change
   * @param tabId - The id of the tab to change to
   */
  onTabChanged(tabId: string) {
    this.activeTab.set(tabId as 'profile' | 'sessions' | 'change-password');
  }

  onCloseClick() {
    this.closeClick.emit();
  }
}
